export default __webpack_public_path__ + "static/media/Bangladesh.d16cf3c9.svg";